import React, { useState } from 'react';
import { useQuery } from 'react-query';
import ConfirmationModal from '../../Shared/ConfirmationModal/ConfirmationModal';
import { useNavigation } from 'react-router-dom';
import Looading from '../../Shared/Looading/Looading';

const Mnagedoctor = () => {

    const [deletingDoctor, setDeletingDoctor] = useState(null)
    const navigation = useNavigation()

    const closeModal = () => {
        setDeletingDoctor(null)
    }
  
    const handleDeleteDoctor = doctor => {
        fetch(`https://denticare-server-sumonhasan55.vercel.app/doctors/${doctor._id}`, {
            method: "DELETE",
            headers: {
                authorization: `bearer ${localStorage.getItem('accessToken')}`
            }
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.deletedCount > 0) {
                    alert(`Doctor ${doctor.name} Finaly deleted Successfully`)
                    refetch()
                }
            })
        console.log(doctor)

    }
   
    const { data: doctors, isLoading, refetch } = useQuery({
        queryKey: ['doctors'],
        queryFn: async () => {
            try {
                const res = await fetch('https://denticare-server-sumonhasan55.vercel.app/doctors', {
                    headers: {
                        authorization: `bearer ${localStorage.getItem('accessToken')}`
                    }

                });
                const data = await res.json();
                return data;

            }
            catch (error) {

            }
        }

    })
    if(navigation.state === "loading"){
        return <Looading></Looading>

    };

    return (
        <div>
            <h1 className='text-3xl text-center font-bold my-5'>ManageDoctors {doctors?.length}</h1>

            <div className="overflow-x-auto w-full">
                <table className="table w-full">
                    {/* head */}
                    <thead>
                        <tr>

                            <th>Doctor Name</th>
                            <th>Email</th>
                            <th>Specialty </th>
                            <th>Manage Doctors</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            doctors?.map((doctor, i) => <tr
                                key={doctor._id}
                            >
                                <td>{i + 1}</td>
                                <td>

                                    <div className="flex items-center space-x-3">
                                        <div className="avatar">
                                            <div className="mask mask-squircle w-12 h-12">
                                                <img src={doctor.image} alt="Avatar Tailwind CSS Component" />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="font-bold">{doctor.name}</div>

                                        </div>
                                    </div>
                                </td>
                                <td>

                                    {doctor.email}


                                </td>
                                <td>{doctor.speciality}</td>
                                <th>
                                    <label onClick={() => setDeletingDoctor(doctor)} htmlFor="my-modal-6" className="btn btn-xs"> Delete Doctor</label>

                                </th>
                            </tr>)
                        }


                    </tbody>



                </table>
                {
                    deletingDoctor && <ConfirmationModal
                        title={`Are you sure you went to delete`}
                        message={`if you delete ${deletingDoctor.name}`}
                        successAction={handleDeleteDoctor}
                        modalData={deletingDoctor}
                        closeModal={closeModal}
                    ></ConfirmationModal>
                }
            </div>
        </div>
    );
};

export default Mnagedoctor;